import React from "react";
import { CCloseButton, CSidebar } from "@coreui/react";
import { alpha } from "@mui/material";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";
import { useNav } from "../../context/NavContext";
import { stringifyName } from "../../utils/helpers";
import { LeftMenu } from "./LeftMenu";
import { primaryColor } from "../styled/Theme";

const AppSidebar = () => {
  const { sidebarShow, setSidebarShow } = useNav();
  const { user } = useAuth();
  const role = user?.role_details?.[0]?.name;
  const userInitial =
    user?.first_name?.trim()?.substring(0, 1)?.toUpperCase() ||
    user?.full_name?.trim()?.substring(0, 1)?.toUpperCase() ||
    "U";

  return (
    <StyledSidebar
      position="fixed"
      unfoldable={false}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        setSidebarShow(visible);
      }}
    >
      <SidebarShell>
        <SidebarHeader>
          <ProfileCard>
            <ProfileAvatar>{userInitial}</ProfileAvatar>

            <ProfileDetails>
              <NameWrapper className="font14 bold">
                {stringifyName(user)}
              </NameWrapper>
              <RoleText>{role || "Team Member"}</RoleText>
            </ProfileDetails>

            <SidebarCloseButton
              className="d-lg-none"
              onClick={() => setSidebarShow(false)}
            />
          </ProfileCard>
        </SidebarHeader>

        <SidebarBody>
          <LeftMenu />
        </SidebarBody>
      </SidebarShell>
    </StyledSidebar>
  );
};

export default React.memo(AppSidebar);

const StyledSidebar = styled(CSidebar)`
  --cui-sidebar-bg: transparent;
  --cui-sidebar-color: #0f172a;
  --cui-sidebar-width: 263px;

  background: #ffffff;
  overflow: hidden;

  @media (max-width: 991.98px) {
    --cui-sidebar-width: min(280px, 88vw);
  }
`;

const SidebarShell = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const SidebarHeader = styled.div`
  flex-shrink: 0;
`;

const ProfileCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px;
  border: 1px solid #e2e8f0;
`;

const ProfileAvatar = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 800;
  color: ${primaryColor};
  background: ${alpha(primaryColor, 0.12)};
  flex-shrink: 0;
`;

const ProfileDetails = styled.div`
  min-width: 0;
  flex: 1;
`;

const RoleText = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.35;
  text-transform: capitalize;
`;

const SidebarBody = styled.div`
  min-height: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-right: 3px;
`;

const SidebarCloseButton = styled(CCloseButton)`
  margin-left: auto;
  background-color: #f1f5f9;
  border-radius: 10px;
  width: 30px;
  height: 30px;
`;

const NameWrapper = styled.div`
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;
